import React from 'react'
import {Bar} from "react-chartjs-2";
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Legend, Title, Tooltip} from "chart.js";
import { LineBarChartData } from './interface'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Title,
  Tooltip
);

export default function Bargraph({barGraphProps} : {barGraphProps : any}) {
  let datasets: {
    label: string;
    data: number[];
    borderWidth: number;
    backgroundColor?: string;
  }[] = [];

  Object.keys(barGraphProps).map((key) => {
    if (key !== "x_axis") {
      if (typeof barGraphProps[key][0] === "object" &&
        barGraphProps[key][0] !== null &&
        !Array.isArray(barGraphProps[key][0])
      ) {
        Object.keys(barGraphProps[key][0]).map((key_of_y_axis) => {
          datasets.push({
            label: key_of_y_axis,
            data: barGraphProps[key][0][key_of_y_axis],
            borderWidth: 1,
            // backgroundColor: "#7f26d3",
          });
        });
      } else if (Array.isArray(barGraphProps[key])) {
        datasets.push({
          label: key,
          data: barGraphProps[key],
          borderWidth: 1,
          // backgroundColor: "#7f26d3",
        });
      }
    } 
  });

  const options = {
    plugins: {
      colors: {
        forceOverride: true,
      },
      legend: {
        display: false,
      },
    },
  };

  const barChartData = {
    labels: barGraphProps.x_axis,
    datasets: [
      {
        label: "",
        data: barGraphProps.y_axis,
        borderWidth: 1,
        backgroundColor: "#7f26d3",
      },
      // {
      //   label: "",
      //   data: barGraphProps.y_axis,
      //   borderWidth: 1,
      //   backgroundColor: "red",
      // },
    ],
    // datasets : datasets
  };
  return <Bar options={options} data={barChartData} />;
}
